<glxy-page [pagePadding]="false" [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'SCORE_SETTINGS.TITLES.EDIT_SCORE' | translate }}</glxy-page-title>
    <glxy-page-actions>
      @if (modified) {
        <span>{{ 'SCORE_SETTINGS.MISC.UNSAVED_CHANGES' | translate }}</span>
      }
      <button mat-flat-button color="primary" (click)="handleSave()" [disabled]="isLoading()">
        {{ 'ACTIONS.SAVE' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  @if (!isLoading()) {
    @if (showEmptyState()) {
      <div class="empty-state">
        <glxy-empty-state>
          <glxy-empty-state-hero>
            <img src="https://storage.googleapis.com/galaxy-libs-public-images/crm/lead-score-empty-state.svg" />
          </glxy-empty-state-hero>
          <glxy-empty-state-title>{{ 'SCORE_SETTINGS.EMPTY_STATE.PAGE.TITLE' | translate }}</glxy-empty-state-title>
          <p>
            {{ 'SCORE_SETTINGS.EMPTY_STATE.PAGE.SUBTITLE' | translate }}
          </p>
          <glxy-empty-state-actions>
            <button mat-flat-button color="primary" (click)="hideEmptyState()">
              {{ 'SCORE_SETTINGS.EMPTY_STATE.PAGE.CREATE_RULE_MYSELF' | translate }}
            </button>
            <button mat-stroked-button (click)="populateWithDefaultScoringDefinitions()">
              {{ 'SCORE_SETTINGS.EMPTY_STATE.PAGE.CREATE_RULE_FOR_ME' | translate }}
            </button>
          </glxy-empty-state-actions>
        </glxy-empty-state>
      </div>
    } @else {
      @if (isMobile$ | async) {
        <mat-tab-group mat-stretch-tabs="true">
          <mat-tab
            label="{{
              'SCORE_SETTINGS.TITLES.POSITIVE' | translate: { numberOfDefinitions: positiveScoringDefinitions().length }
            }}"
          >
            <div class="header">
              <div class="header-wrapper">
                <div class="sub-title">{{ 'SCORE_SETTINGS.SUBTITLES.POSITIVE' | translate }}</div>
                <button
                  mat-stroked-button
                  class="add-criteria-button"
                  (click)="addCriteria('positive')"
                  [disabled]="isLoading()"
                >
                  <mat-icon>add</mat-icon>
                  {{ 'SCORE_SETTINGS.CTA.ADD_CRITERIA' | translate }}
                </button>
              </div>
            </div>
            <div class="items">
              <crm-scoring-definition-section
                [scoringDefinitions]="positiveScoringDefinitions()"
                (scoringDefinitionsChange)="handlePositiveScoringDefinitionsChange($event)"
                [objectType]="objectType()"
                [disabled]="isLoading()"
                (modified)="handleSectionModified()"
              ></crm-scoring-definition-section>
            </div>
          </mat-tab>
          <mat-tab
            label="{{
              'SCORE_SETTINGS.TITLES.NEGATIVE' | translate: { numberOfDefinitions: negativeScoringDefinitions().length }
            }}"
          >
            <div class="header">
              <div class="header-wrapper">
                <div class="sub-title">{{ 'SCORE_SETTINGS.SUBTITLES.NEGATIVE' | translate }}</div>
                <button
                  mat-stroked-button
                  class="add-criteria-button"
                  (click)="addCriteria('negative')"
                  [disabled]="isLoading()"
                >
                  <mat-icon>add</mat-icon>
                  {{ 'SCORE_SETTINGS.CTA.ADD_CRITERIA' | translate }}
                </button>
              </div>
            </div>
            <div class="items">
              <crm-scoring-definition-section
                [scoringDefinitions]="negativeScoringDefinitions()"
                (scoringDefinitionsChange)="handleNegativeScoringDefinitionsChange($event)"
                [objectType]="objectType()"
                [disabled]="isLoading()"
                (modified)="handleSectionModified()"
              ></crm-scoring-definition-section>
            </div>
          </mat-tab>
        </mat-tab-group>
      } @else {
        <div class="layout">
          <div class="positive">
            <div class="header">
              <div class="header-wrapper">
                <div class="title">
                  {{
                    'SCORE_SETTINGS.TITLES.POSITIVE'
                      | translate: { numberOfDefinitions: positiveScoringDefinitions().length }
                  }}
                </div>
                <div class="sub-title">{{ 'SCORE_SETTINGS.SUBTITLES.POSITIVE' | translate }}</div>
                <button
                  mat-stroked-button
                  class="add-criteria-button"
                  (click)="addCriteria('positive')"
                  [disabled]="isLoading()"
                >
                  <mat-icon>add</mat-icon>
                  {{ 'SCORE_SETTINGS.CTA.ADD_CRITERIA' | translate }}
                </button>
              </div>
            </div>
            <div class="items">
              <crm-scoring-definition-section
                [scoringDefinitions]="positiveScoringDefinitions()"
                (scoringDefinitionsChange)="handlePositiveScoringDefinitionsChange($event)"
                [objectType]="objectType()"
                [disabled]="isLoading()"
                (modified)="handleSectionModified()"
              ></crm-scoring-definition-section>
            </div>
          </div>
          <div class="negative">
            <div class="header">
              <div class="header-wrapper">
                <div class="title">
                  {{
                    'SCORE_SETTINGS.TITLES.NEGATIVE'
                      | translate: { numberOfDefinitions: negativeScoringDefinitions().length }
                  }}
                </div>
                <div class="sub-title">{{ 'SCORE_SETTINGS.SUBTITLES.NEGATIVE' | translate }}</div>
                <button
                  mat-stroked-button
                  class="add-criteria-button"
                  (click)="addCriteria('negative')"
                  [disabled]="isLoading()"
                >
                  <mat-icon>add</mat-icon>
                  {{ 'SCORE_SETTINGS.CTA.ADD_CRITERIA' | translate }}
                </button>
              </div>
            </div>
            <div class="items">
              <crm-scoring-definition-section
                [scoringDefinitions]="negativeScoringDefinitions()"
                (scoringDefinitionsChange)="handleNegativeScoringDefinitionsChange($event)"
                [objectType]="objectType()"
                [disabled]="isLoading()"
                (modified)="handleSectionModified()"
              ></crm-scoring-definition-section>
            </div>
          </div>
        </div>
      }
    }
  }
</glxy-page>
